import React from 'react'

import Header from '../Header'
import { Outlet } from 'react-router-dom'

function index() {
  return (
    <>
      <Header />
      <Outlet />
    </>
  )
}

export default index